import { ref, computed, watch } from 'vue'
import { useTextareaAutosize } from '@vueuse/core'

import type { AppTextareaProps, AppTextareaEvent } from '../types/interfaces'

interface AppTextareaOptions {
  props: AppTextareaProps
  onChange: (event: AppTextareaEvent) => void
  onInput: (event: AppTextareaEvent) => void
  onFocus: (event: AppTextareaEvent) => void
  onBlur: (event: AppTextareaEvent) => void
}

interface AppTextareaReturn {
  refTextarea: Ref<HTMLTextAreaElement | null>
  refValue: Ref<string>
  refIsError: ComputedRef<boolean>
  refIsSuccess: ComputedRef<boolean>
  handleChange: () => void
  handleInput: () => void
  handleFocus: () => void
  handleBlur: () => void
}

export const useAppTextarea = ({ props, onChange, onInput, onFocus, onBlur }: AppTextareaOptions): AppTextareaReturn => {
  const refTextarea = ref<HTMLTextAreaElement | null>(null)
  const refValue = ref<string>(props.value ?? '')

  useTextareaAutosize({ // FIXME: ts-expect-error
    // @ts-expect-error any
    element: () => refTextarea.value ?? undefined,
    input: refValue,
  })

  const refIsError = computed<boolean>(() => props.mode === 'error')
  const refIsSuccess = computed<boolean>(() => props.mode === 'success')

  const buildEvent = (): AppTextareaEvent => ({
    id: props.id,
    value: refValue.value,
    required: props.required,
  })

  const handleChange = (): void => {
    onChange(buildEvent())
  }

  const handleInput = (): void => {
    onInput(buildEvent())
  }

  const handleFocus = (): void => {
    onFocus(buildEvent())
  }

  const handleBlur = (): void => {
    onBlur(buildEvent())
  }

  watch(() => props.value, (value) => {
    if (value !== refValue.value) refValue.value = value ?? ''
  })

  return {
    refTextarea,
    refValue,
    refIsError,
    refIsSuccess,
    handleChange,
    handleInput,
    handleFocus,
    handleBlur,
  }
}
